import { mapPrice, mapReducedPrice } from "../mapPrice";
import { mapBadgeType } from "./mapBadge";

export const mapProduct = ({ product }) => ({
  id: product.id,
  productCode: product.productCode,
  url: product.url,
  price: mapPrice(product.price),
  description: product.name,
  image: product.imageUrl,
  badgeType: mapBadgeType(product),
  productType: product.productType,
  colourWayId: product.colourWayId,
  isSale: product.price.isMarkedDown,
  reducedPrice: mapReducedPrice(product.price),
  hasMultiplePrices: product.hasMultiplePrices,
  isOutlet: product.price.isOutletPrice,
  isSellingFast: product.isSellingFast,
  brandName: product.brandName,
  colour: product.colour
});

export default mapProduct;
